import React from "react";
import useImage from "use-image";
import { Group, Image, Rect } from "react-konva";
import { useSelector } from "react-redux";
import { roofStructureData } from "../structureFunction";
import { handleImageDimension } from "../structurePlacementFunction/customizeStructurePlacement";
import {
  getPixelsPerMeter,
  handleSmithStrDim,
} from "../structurePlacementFunction/smithStructure";
import { panelInformation } from "../../../DataFiles/panelInformation";

export default function AddImage({ currentPos }) {
  let structureItem, imgSrc, imgDimension;
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const designParameter = useSelector((state) => state.designParameter);
  const roofData = quantityInfo.roofData;
  const roofIndex = quantityInfo.roofNo;
  const roofDetail = roofData.length > 0 ? roofData[roofIndex] : [];
  const images = roofDetail?.images || [];
  const mountingStructure = roofDetail.mountingStructure;
  let panel = [];

  if (roofDetail.module) {
    let panelInfo = panelInformation.find(
      (item) => item.brand === roofDetail.module
    );

    panel = panelInfo.panelType.find(
      (item) => item.name === roofDetail.moduleType
    );
  }

  let pixelMultiple = getPixelsPerMeter(roofInfo);

  let width;
  let height;
  if (mountingStructure && mountingStructure !== "Select") {
    structureItem = roofStructureData.find(
      (element) => element.name === roofDetail.mountingStructure
    );

    if (structureItem) {
      imgSrc = structureItem.structureImgSrc;
      imgDimension = {
        height: structureItem.height * pixelMultiple,
        width: structureItem.width * pixelMultiple,
        gap: structureItem.gap * pixelMultiple,
      };
    }
  }

  if (roofDetail.customizeStructure) {
    imgDimension = handleImageDimension({
      roofInfo,
      roofDetail,
      designParameter,
    });
    width =
      (imgDimension.width -
        (imgDimension.colFrame - 1) * imgDimension.moduleSpacing) /
      imgDimension.colFrame;
    height =
      (imgDimension.height -
        (imgDimension.rowFrame - 1) * imgDimension.moduleSpacing) /
      imgDimension.rowFrame;
  }

  if (roofDetail.newStructure) {
    imgDimension = handleSmithStrDim({
      roofInfo,
      roofDetail,
      structureItem,
      panel,
    });
    width =
      (imgDimension.width -
        (imgDimension.colFrame - 1) * imgDimension.moduleSpacing) /
      imgDimension.colFrame;
    height =
      (imgDimension.height -
        (imgDimension.rowFrame - 1) * imgDimension.moduleSpacing) /
      imgDimension.rowFrame;
  }

  const [img] = useImage(imgSrc);

  return (
    <React.Fragment>
      {roofDetail.customizeStructure || roofDetail.newStructure ? (
        <Group
          x={currentPos ? currentPos.x : 30}
          y={currentPos ? currentPos.y : 30}
          rotation={
            images.length > 0 && roofDetail.customCapacityType === "Custom"
              ? images[0].angleDegree
              : 0
          }
        >
          {Array.from({ length: imgDimension?.rowFrame || 0 }).map(
            (_, rowIndex) =>
              Array.from({ length: imgDimension?.colFrame || 0 }).map(
                (_, colIndex) => (
                  <Rect
                    key={`${rowIndex}-${colIndex}`}
                    x={colIndex * (width + imgDimension?.moduleSpacing || 0)}
                    y={rowIndex * (height + imgDimension?.moduleSpacing || 0)}
                    width={width}
                    height={height}
                    fill="#27326A"
                  />
                )
              )
          )}
        </Group>
      ) : (
        <Image
          image={img}
          x={currentPos ? currentPos.x : 30}
          y={currentPos ? currentPos.y : 30}
          width={imgDimension ? imgDimension.width : 0}
          height={imgDimension ? imgDimension.height : 0}
          rotation={
            images.length > 0 && roofDetail.customCapacityType === "Custom"
              ? images[0].angleDegree
              : 0
          }
        />
      )}
    </React.Fragment>
  );
}
